import { render } from "./Supplementplus20250114.vue?vue&type=template&id=2ff922b4&scoped=true"
import script from "./Supplementplus20250114.vue?vue&type=script&lang=js"
export * from "./Supplementplus20250114.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Nomura\\PROJECT\\010.Src_By_SYSLAB\\007.MCSC_Web\\Git_main\\FrontEnd\\site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff922b4"]])

export default __exports__